<template>
  <div>
    <h2 class="step-name">Contact Details</h2>

    <div class="step-section">
      <p>These details are visible in ezyVet and changes will be posted to ezyVet</p>
      <div class="jumbotron jumbotron-client">
        <div class="row">
          <div class="col-md-5">
            <dl class="dl-horizontal">
              <dt>Name</dt>
              <dd>{{ contactDetails.full_name }}</dd>
            </dl>
            <dl class="dl-horizontal">
              <dt>Address</dt>
              <dd>{{ contactDetails.street || '-' }}</dd>
              <dd>{{ contactDetails.address1 || '-' }}</dd>
              <dd>{{ contactDetails.address2 || '-' }}</dd>
              <dd>{{ contactDetails.address3 || '-' }}</dd>
              <dd>{{ contactDetails.postcode || '-' }}</dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
    <div class="step-section">
      <div class="form-group">
        <div
          class="row"
          v-for="(contactdetail, index) in getFieldValue('CONTACT_DETAILS')"
          :key="`contactdetail__${index}`"
        >
          <div class="col-md-2">
            <text-input
              label="Name"
              :disabled="isReadOnly || !getFieldValue(`contactdetail_${contactdetail.id}-active`)"
              :vvalidate="getFieldValue(`contactdetail_${contactdetail.id}-active`) ? 'required' : ''"
              @on-change="checkAndCompleteStep"
              :field-name="`contactdetail_${contactdetail.id}-name`"
              :show-input-box="false"
            >
            </text-input>
          </div>
          <div class="col-md-2">
            <text-input
              label="Value"
              :disabled="isReadOnly || !getFieldValue(`contactdetail_${contactdetail.id}-active`)"
              :vvalidate="getFieldValue(`contactdetail_${contactdetail.id}-active`) ? 'required' : ''"
              @on-change="checkAndCompleteStep"
              :field-name="`contactdetail_${contactdetail.id}-value`"
              :show-input-box="false"
            >
            </text-input>
          </div>
          <div class="col-md-2">
            <select-input
              label="Type"
              :disabled="isReadOnly || !getFieldValue(`contactdetail_${contactdetail.id}-active`)"
              :vvalidate="getFieldValue(`contactdetail_${contactdetail.id}-active`) ? 'required' : ''"
              @on-change="checkAndCompleteStep"
              :field-name="`contactdetail_${contactdetail.id}-contact_detail_type`"
              :options="contactDetailTypeOptions"
              :show-input-box="false"
            >
            </select-input>
          </div>
          <div class="col-md-2">
            <select-check-box-input
              label="Subscription Groups"
              @on-change="checkAndCompleteStep"
              :options="subscriptionGroupsOptions"
              :field-name="`contactdetail_${contactdetail.id}-subscription_groups`"
              :disabled="isReadOnly || !getFieldValue(`contactdetail_${contactdetail.id}-active`)"
              :show-input-box="false"
            >
            </select-check-box-input>
          </div>
          <div class="col-md-2">
            <check-box
              style="margin-top: 32px"
              label="Preferred"
              @on-change="checkAndCompleteStep"
              :field-name="`contactdetail_${contactdetail.id}-preferred`"
              :disabled="isReadOnly || !getFieldValue(`contactdetail_${contactdetail.id}-active`)"
              :show-input-box="false"
            >
            </check-box>
          </div>
          <div class="col-md-2">
            <check-box
              style="margin-top: 32px; text-align: left"
              :label="getFieldValue(`contactdetail_${contactdetail.id}-active`) ? 'Enabled' : 'Disabled'"
              @on-change="toggleContactDetailActive(contactdetail)"
              :field-name="`contactdetail_${contactdetail.id}-active`"
              :show-input-box="false"
            >
            </check-box>
          </div>
        </div>
      </div>

      <div class="text-right" style="padding-right: 220px" v-if="!isReadOnly">
        <span
          class="glyphicon glyphicon-plus-sign"
          style="color: green; cursor: pointer"
          v-tooltip="'Add Contact Detail'"
          @click.prevent="canAdd ? addNewContactDetail() : ''"
          :disabled="!canAdd"
          :class="{ disabled: !canAdd }"
              :show-input-box="false"
        >
        </span>
      </div>
      <div class="form-group">
        <div class="alert alert-danger" v-if="!checkUnique()">
          <span class="glyphicon glyphicon-warning-sign"></span>
          Please make sure values are unique.
        </div>
        <div
          class="row"
          v-for="(contactdetail, index) in getFieldValue('NEW_CONTACT_DETAILS')"
          :key="`newcontactdetail__${index}`"
        >
          <div class="col-md-2">
            <text-input
              label="Name"
              required
              @on-change="checkAndCompleteStep"
              :disabled="isReadOnly || !getFieldValue(`newcontactdetail_${contactdetail.frontend_id}-active`)"
              :field-name="`newcontactdetail_${contactdetail.frontend_id}-name`"
              :show-input-box="false"
            >
            </text-input>
          </div>
          <div class="col-md-2">
            <text-input
              label="Value"
              required
              :disabled="isReadOnly || !getFieldValue(`newcontactdetail_${contactdetail.frontend_id}-active`)"
              @on-change="checkAndCompleteStep"
              :field-name="`newcontactdetail_${contactdetail.frontend_id}-value`"
              :show-input-box="false"
            >
            </text-input>
          </div>
          <div class="col-md-2">
            <select-input
              label="Type"
              required
              :disabled="isReadOnly || !getFieldValue(`newcontactdetail_${contactdetail.frontend_id}-active`)"
              @on-change="checkAndCompleteStep"
              :field-name="`newcontactdetail_${contactdetail.frontend_id}-contact_detail_type`"
              :options="contactDetailTypeOptions"
              :show-input-box="false"
            >
            </select-input>
          </div>

          <div class="col-md-2 text-left">
            <select-check-box-input
              label="Subscription Groups"
              @on-change="checkAndCompleteStep"
              :options="subscriptionGroupsOptions"
              :field-name="`newcontactdetail_${contactdetail.frontend_id}-subscription_groups`"
              :show-input-box="false"
            >
            </select-check-box-input>
          </div>
          <div class="col-md-2">
            <check-box
              style="margin-top: 32px"
              label="Preferred"
              @on-change="checkAndCompleteStep"
              :field-name="`newcontactdetail_${contactdetail.frontend_id}-preferred`"
              :show-input-box="false"
            >
            </check-box>
          </div>
          <div class="col-md-2 text-left" v-if="!isReadOnly">
            <span
              class="glyphicon glyphicon-minus-sign"
              v-tooltip="'Remove Contact Detail'"
              style="color: red; cursor: pointer; margin-top: 32px; text-align: left"
              @click.prevent="removeNewContactDetail(contactdetail)"
            >
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="step-section">
      <div v-if="hasAddresses">
        <h4>Addresses</h4>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Name</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in getChartData('addresses')" :key="'address_' + index">
              <td class="text-left">{{ row['name'] }}</td>
              <td class="text-left">{{ row['value'] }}</td>
            </tr>
          </tbody>
        </table>
        <div class="form-group">
          <span class="form-group">
            <label>
              Changes to send to Farm Services
              <i
                class="glyphicon glyphicon-envelope"
                v-tooltip="'Email might be generated'"
                title="Email might be generated"
              >
              </i>
            </label>
            <comments
              field-name="address_notes_for_farm_services"
              :addEmailNotification="true"
              :isReadOnly="isReadOnly"
            >
            </comments>
          </span>
        </div>
        <div class="alert alert-info">
          Since addresses cannot be updated here please add details of any changes to addresses so that farm services
          can update client information in ezyVet. Changes to contact details will be noted here automatically. Please
          add information relating to communications or reminders.
        </div>
      </div>
    </div>

    <div class="step-section">
      <div class="form-group">
        <radio-input
          label="On farm deliveries?"
          @on-change="toggleNotifications"
          :add-email-notification="true"
          field-name="wants_on_farm_deliveries"
          :choices="[
            { value: 'Yes', display: 'Yes' },
            { value: 'No', display: 'No' },
          ]"
        >
        </radio-input>
        <small class="form-text text-muted"> Default delivery is monthly. Discuss online ordering </small>
      </div>
      <text-area
        label="Contact person's name and number for delivery driver."
        field-name="on_farm_delivery_details_text"
        @on-change="toggleOnFarmDeliveries"
        :disabled="isReadOnly"
      >
      </text-area>
      <table class="table table-bordered" v-if="hasDeliveryInfo">
        <thead>
          <tr>
            <th>Animal</th>
            <th>Delivery</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(fsa, index) in getChartData('DELIVERY_INFO')" :key="'deliveryinfo' + index">
            <td class="text-left">{{ fsa['animal'] }}</td>
            <td class="text-left">{{ fsa['delivery'] }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import baseComponent from '@/mixins/base_consult_component_v2'

const REQUIRED_CONTACT_DETAIL_FIELDS = ['name', 'value', 'contact_detail_type']
const CONTACT_DETAIL_FIELDS = ['name', 'value', 'contact_detail_type', 'subscription_groups', 'preferred']

export default {
  name: 'ContactDetails',
  mixins: [baseComponent],
  data() {
    return {
      canAdd: true,
    }
  },
  created() {
    this.checkUnique()
    let newRequiredFields =
      (this.getFieldValue('CONTACT_DETAILS', this.$options.name) || [])
        .filter((cd) => this.getFieldValue(`contactdetail_${cd.id}-active`))
        .map((cd) => REQUIRED_CONTACT_DETAIL_FIELDS.map((cdf) => `contactdetail_${cd.id}-${cdf}`))
        .flat() || []
    newRequiredFields.concat(
      this.getFieldValue('NEW_CONTACT_DETAILS')
        .map((cd) => REQUIRED_CONTACT_DETAIL_FIELDS.map((cdf) => `newcontactdetail_${cd.frontend_id}-${cdf}`))
        .flat()
    )
    this.addRequiredFields({
      stepName: 'ContactDetails',
      value: newRequiredFields,
    })
    this.checkAndCompleteStep()
  },
  methods: {
    ...mapActions('currentConsult', ['deleteField', 'addRequiredFields', 'removeRequiredFields', 'setFieldComment']),
    subscriptionGroupsDisplay: function (contactdetail) {
      return (
        this.getFieldValue(this.prefixedField('subscription_groups', contactdetail.id, 'contactdetail')) || []
      ).join(', ')
    },
    toggleOnFarmDeliveries: function ({ value }) {
      if (value) {
        this.setFieldValue({
          fieldName: 'wants_on_farm_deliveries',
          value: 'Yes',
          stepName: this.$options.name,
        })
      }
      // keep comment in sync so we dont need to change EmailNotifications UI just for this.
      let payload = { fieldName: 'delivery_notes', modelName: this.$options.name, value: value }
      this.setFieldComment(payload)
    },
    toggleContactDetailActive: function (contactdetail) {
      let fieldsData = {
        stepName: this.$options.name,
        value: REQUIRED_CONTACT_DETAIL_FIELDS.map((cdf) => `contactdetail_${contactdetail.id}-${cdf}`),
      }

      if (this.getFieldValue(`contactdetail_${contactdetail.id}-active`)) {
        this.addRequiredFields(fieldsData)
      } else {
        this.removeRequiredFields(fieldsData)
      }
      this.checkAndCompleteStep()
    },
    validate() {
      // check all new contact details have values
      if (
        !this.newCDs.every((cd) =>
          REQUIRED_CONTACT_DETAIL_FIELDS.every((field) =>
            this.getFieldValue(`newcontactdetail_${cd.frontend_id}-${field}`, 'ContactDetails')
          )
        )
      ) {
        // console.log('new cds not complete')
        return false
      }

      // check all old contact details have values
      if (
        !this.oldCDs
          .filter((cd) => this.getFieldValue(`contactdetail_${cd.id}-active`, this.$options.name))
          .every((cd) =>
            REQUIRED_CONTACT_DETAIL_FIELDS.every((field) =>
              this.getFieldValue(`contactdetail_${cd.id}-${field}`, 'ContactDetails')
            )
          )
      ) {
        // console.log('old cds not complete')
        return false
      }

      // check `value` is unique for all active contact details
      return this.checkUnique()
    },
    checkUnique() {
      let valueFields = []
      for (let cd of this.oldCDs.filter((cd) =>
        this.getFieldValue(`contactdetail_${cd.id}-active`, this.$options.name)
      )) {
        if (this.getFieldValue(`contactdetail_${cd.id}-active`, 'ContactDetails')) {
          valueFields.push(`contactdetail_${cd.id}-value`)
        }
      }
      for (let cd of this.newCDs) {
        valueFields.push(`newcontactdetail_${cd.frontend_id}-value`)
      }
      let valuesToCheck = []
      for (let valueField of valueFields) {
        valuesToCheck.push(this.getFieldValue(valueField, 'ContactDetails'))
      }

      if (valuesToCheck.length != new Set(valuesToCheck).size) {
        // console.log('non unique values present')
        return false
      }

      return true
    },
    addNewContactDetail() {
      this.canAdd = false
      let newContactDetails = this.getFieldValue('NEW_CONTACT_DETAILS')
      let newConatctDetail = {
        frontend_id: Math.max(...newContactDetails.concat([{ frontend_id: 0 }]).map((cd) => cd.frontend_id)) + 1,
      }
      this.setFieldValue({ fieldName: 'NEW_CONTACT_DETAILS', value: newContactDetails.concat([newConatctDetail]) })
      let allNewFields = []
      for (let field of CONTACT_DETAIL_FIELDS) {
        let fieldName = `newcontactdetail_${newConatctDetail.frontend_id}-${field}`
        this.setFieldValue({
          fieldName: fieldName,
          value: null,
        })
        allNewFields.push(fieldName)
      }
      this.setFieldValue({
        stepName: 'ContactDetails',
        fieldName: `newcontactdetail_${newConatctDetail.frontend_id}-active`,
        value: true,
      })
      this.addRequiredFields({
        stepName: 'ContactDetails',
        value: allNewFields.concat([`newcontactdetail_${newConatctDetail.frontend_id}-active`]),
      })
      this.checkAndCompleteStep()
      this.canAdd = true
    },
    removeNewContactDetail(newcontactdetail) {
      let newContactDetails = this.getFieldValue('NEW_CONTACT_DETAILS').filter(
        (cd) => cd.frontend_id != newcontactdetail.frontend_id
      )
      this.setFieldValue({ fieldName: 'NEW_CONTACT_DETAILS', value: newContactDetails })

      let allNewFields = []
      for (let field of CONTACT_DETAIL_FIELDS) {
        let fieldName = `newcontactdetail_${newcontactdetail.frontend_id}-${field}`
        this.deleteField({ fieldName })
        allNewFields.push(fieldName)
      }
      this.removeRequiredFields({
        stepName: 'ContactDetails',
        value: allNewFields.concat([`newcontactdetail_${newcontactdetail.frontend_id}-active`]),
      })
      this.checkAndCompleteStep()
    },
    ...mapMutations('currentConsult', ['addContact', 'editContact', 'addRole', 'editRole', 'removeContact']),
    toggleNotifications: function () {
      this.setEmailNotification({
        slug: 'wants-on-farm-deliveries',
        value: Boolean(this.getFieldValue('wants_on_farm_deliveries', this.$options.name) == 'Yes'),
      })

      this.setEmailNotification({
        slug: 'gfc-addresses-farm-services-notes',
        value: Boolean(this.getFieldComment('address_notes_for_farm_services', this.$options.name).current),
      })
    },
  },
  computed: {
    ...mapGetters('currentConsult', ['isReadOnly']),
    hasAddresses: function () {
      return ((this.getFieldValue('CHARTS') || {})['addresses'] || []).length > 0
    },
    subscriptionGroupsOptions: function () {
      return ['Accounts', 'General', 'Reminders'].map((sg) => {
        return { display: sg, value: sg }
      })
    },
    hasDeliveryInfo: function () {
      return ((this.getFieldValue('CHARTS') || {})['DELIVERY_INFO'] || []).length > 0
    },
    oldCDs: function () {
      return this.getFieldValue('CONTACT_DETAILS', 'ContactDetails')
    },
    newCDs: function () {
      return this.getFieldValue('NEW_CONTACT_DETAILS', 'ContactDetails')
    },
    contactDetailTypeOptions: function () {
      return this.getFieldValue('CONTACT_DETAIL_TYPES').map((cd) => {
        return { value: cd.id, display: cd.name }
      })
    },
    contactDetails: function () {
      return {
        full_name: this.getFieldValue('full_name'),
        address1: this.getFieldValue('address1'),
        address2: this.getFieldValue('address2'),
        address3: this.getFieldValue('address3'),
        street: this.getFieldValue('street'),
        postcode: this.getFieldValue('postcode'),
      }
    },
  },
}
</script>

<style scoped>
span.herd_name {
  display: block;
}
.jumbotron {
  padding-top: 20px;
  padding-bottom: 20px;
}
.actions {
  text-align: right;
}
</style>
